import MetricsBreadcrumbs from '@/metrics/components/MetricsBreadcrumbs/MetricsBreadcrumbs'

import MostReturnedCardSkeleton from '../MostReturnedCardSkeleton/MostReturnedCardSkeleton'
import MostReturnedProduct from '../MostReturnedProduct/MostReturnedProduct'
import * as Styles from './styles'

const MostReturnedContent = ({
  loading,
  item,
  breadcrumbs,
  count,
  percentage,
  countText,
  percentageText,
  sales,
  salesOrdersDataActivated,
}) => {
  if (loading) {
    return <MostReturnedCardSkeleton />
  }

  return (
    <Styles.Container>
      {breadcrumbs && <MetricsBreadcrumbs breadcrumbs={breadcrumbs} />}
      <MostReturnedProduct
        item={item}
        count={count}
        percentage={percentage}
        countText={countText}
        percentageText={percentageText}
        sales={sales}
        salesOrdersDataActivated={salesOrdersDataActivated}
      />
    </Styles.Container>
  )
}

export default MostReturnedContent
